import type { ButtonProps } from '@makemydeal/dr-ui-bricks-types';
import { ButtonStyle } from '@makemydeal/dr-ui-bricks-types';
import { PrimaryButton, SecondaryButton, TertiaryButton } from './button.style';

const Button: React.FC<ButtonProps> = ({
    width,
    children,
    className = '',
    buttonStyle = ButtonStyle.PRIMARY,
    buttonSize = 'large',
    disabled = false,
    type = 'button',
    onClick,
    'data-testid': dataTestId
}) => {
    switch (buttonStyle) {
        case ButtonStyle.SECONDARY:
            return (
                <SecondaryButton
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                </SecondaryButton>
            );
        case ButtonStyle.TERTIARY:
            return (
                <TertiaryButton
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                </TertiaryButton>
            );
        default:
            return (
                <PrimaryButton
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                </PrimaryButton>
            );
    }
};
export default Button;
